export interface FilterRequestContext {
    showArchived: boolean;
    siteSelected?: any;
    paginationModel?: { page: number; pageSize: number };
    userId?: string | number;
    extraContext?: Record<string, any>;
}

export interface ModuleFilterStrategy {
    getTabStatusOverlay(tab: string, runtimeContext?: { listValues?: any }): Record<string, any>;
    augmentRequest(req: Record<string, any>, context: FilterRequestContext): Record<string, any>;
}

export const defaultFilterStrategy: ModuleFilterStrategy = {
    getTabStatusOverlay: () => ({}),
    augmentRequest: (req) => req,
};
